module.exports = __webpack_public_path__ + "img/phon2.9103a92a.png";